<template>
  <div class="navbar_wrap hidden-xs-only">
    <div class="navbar_container">
      <div class="navbar_left">
        <img
          src="@/assets/img/home/logo.png"
          alt="万知创造..."
          class="navbar_logo"
        />
      </div>
      <div class="navbar_right">
        <el-menu
          :default-active="activeIndex"
          class="el_menu_demo"
          mode="horizontal"
          background-color="rgba(0,0,0,0)"
          text-color="#000"
          active-text-color="#000"
          @select="changeCurrentPage"
        >
          <el-menu-item index="1" class="menu_item">首頁</el-menu-item>
          <el-submenu index="5">
            <template slot="title">關於萬知</template>
            <el-menu-item index="5-1" class="menu_item">萬知介紹</el-menu-item>
            <el-menu-item index="5-4" class="menu_item">聯繫萬知</el-menu-item>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">智慧服務</template>
            <el-menu-item index="3-1" class="menu_item">軟件開發</el-menu-item>
            <el-menu-item index="3-2" class="menu_item">AI 賦能</el-menu-item>
            <el-menu-item index="3-3" class="menu_item"
              >投審稿系統</el-menu-item
            >
            <el-menu-item index="3-4" class="menu_item"
              >智能編排校</el-menu-item
            >
            <el-menu-item index="3-5" class="menu_item"
              >智能協作平臺</el-menu-item
            >
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">科研服務</template>
            <el-menu-item index="2-7" class="menu_item">實驗服務</el-menu-item>
            <el-menu-item index="2-2" class="menu_item">課題服務</el-menu-item>
          </el-submenu>
          <el-submenu index="4" class="menu_item">
            <template slot="title">國際業務</template>
            <el-menu-item index="4-15" class="menu_item">國際會議</el-menu-item>
            <el-menu-item index="4-2" class="menu_item">國際教育</el-menu-item>
            <el-menu-item index="4-3" class="menu_item">知識產權</el-menu-item>
            <el-menu-item index="4-4" class="menu_item">國際期刊</el-menu-item>
            <el-menu-item index="4-5" class="menu_item">網文出海</el-menu-item>
            <el-menu-item index="4-6" class="menu_item"
              >國際專著出書</el-menu-item
            >
            <el-menu-item index="4-7" class="menu_item">譯著</el-menu-item>
          </el-submenu>
          <el-menu-item index="6" class="menu_item">投資</el-menu-item>
        </el-menu>
        <span class="right_phone"> <span>繁體</span>/<span>英文</span> </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "1"
    };
  },
  props: {
    selectIndex: {
      type: String,
      default: "0"
    }
  },
  mounted() {
    this.activeIndex = this.selectIndex;
  },
  methods: {
    changeCurrentPage(index) {
      this.activeIndex = index;
      switch (this.activeIndex) {
        case "1":
          this.$router.push("/home").catch(v => {});
          break;
        case "2-2":
          this.$router.push("/scientific/2").catch(v => {});
          break;
        case "2-7":
          this.$router.push("/scientific/1").catch(v => {});
          break;
        case "3-1":
          this.$router.push("/intelligent/1").catch(v => {});
          break;
        case "3-2":
          this.$router.push("/intelligent/2").catch(v => {});
          break;
        case "3-3":
          this.$router.push("/intelligent/3").catch(v => {});
          break;
        case "3-4":
          this.$router.push("/intelligent/4").catch(v => {});
          break;
        case "3-5":
          this.$router.push("/intelligent/5").catch(v => {});
          break;
        case "4-15":
          this.$router.push("/international/1").catch(v => {});
          break;
        case "4-2":
          this.$router.push("/international/2").catch(v => {});
          break;
        case "4-3":
          this.$router.push("/international/3").catch(v => {});
          break;
        case "4-4":
          this.$router.push("/international/4").catch(v => {});
          break;
        case "4-5":
          this.$router.push("/international/5").catch(v => {});
          break;
        case "4-6":
          this.$router.push("/international/6").catch(v => {});
          break;
        case "4-7":
          this.$router.push("/international/7").catch(v => {});
          break;
        case "5-1":
          this.$router.push("/fivenav/1").catch(v => {});
          break;
        case "5-4":
          this.$router.push("/fivenav/2").catch(v => {});
          break;
        case "6":
          this.$router.push("/investment").catch(v => {});
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar_wrap {
  width: 100%;
  height: 80px;
  background: rgba(235, 234, 234, 0.3);
  backdrop-filter: saturate(180%) blur(8px);
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.3s ease;

  @media screen and (max-width: 768px) {
    height: 56px !important;
  }

  @media screen and (max-width: 1024px) {
    height: 70px;
  }

  @media screen and (max-width: 1440px) {
    height: 75px;
  }

  .navbar_container {
    width: 90%;
    max-width: 1920px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;

    .navbar_left {
      flex-shrink: 0;
      width: 320px;
      transition: width 0.3s ease;

      @media screen and (max-width: 768px) {
        width: 200px;
      }

      @media screen and (max-width: 1024px) {
        width: 240px;
      }

      @media screen and (max-width: 1440px) {
        width: 280px;
      }

      .navbar_logo {
        width: 100%;
        height: auto;
        display: block;
        object-fit: contain;
      }
    }

    .navbar_right {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 16px;
      transition: all 0.3s ease;

      @media screen and (max-width: 768px) {
        font-size: 12px;
      }

      @media screen and (max-width: 1024px) {
        font-size: 14px;
      }

      @media screen and (max-width: 1440px) {
        font-size: 15px;
      }

      .el_menu_demo {
        border: none;
        display: flex;
        align-items: center;

        @media screen and (max-width: 1024px) {
          ::v-deep .el-menu-item,
          ::v-deep .el-submenu__title {
            padding: 0 12px !important;
            font-size: 14px !important;
          }
        }

        @media screen and (max-width: 768px) {
          ::v-deep .el-menu-item,
          ::v-deep .el-submenu__title {
            padding: 0 8px !important;
            font-size: 12px !important;
          }
        }
      }

      .menu_item {
        transition: all 0.3s ease;
        &:hover {
          font-weight: 600;
          background: transparent !important;
        }
      }

      .right_phone {
        transition: all 0.5s;
        display: flex;
        align-items: center;
        margin-left: 20px;
        padding-left: 20px;
        border-left: 1px solid rgba(0, 0, 0, 0.2);
        cursor: pointer;

        @media screen and (max-width: 768px) {
          margin-left: 10px;
          padding-left: 10px;
          font-size: 12px;
        }

        &:hover {
          color: #666;
        }

        span {
          white-space: nowrap;
        }
      }
    }
  }
}

// 大屏适配
@media screen and (min-width: 1920px) {
  .navbar_wrap {
    .navbar_container {
      max-width: 2560px;

      .navbar_left {
        width: 400px;
      }

      .navbar_right {
        font-size: 18px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/index.vue